module.exports = __webpack_public_path__ + "img/zoom-revenue-accelerator.4b8ee07b.svg";